var UnsupportedBrowserWarningComponent = /** @class */ (function () {
    function UnsupportedBrowserWarningComponent() {
    }
    Object.defineProperty(UnsupportedBrowserWarningComponent.prototype, "isBrowserSupported", {
        get: function () {
            return !/MSIE|Trident|Edge/.test(window.navigator.userAgent);
        },
        enumerable: true,
        configurable: true
    });
    return UnsupportedBrowserWarningComponent;
}());
export { UnsupportedBrowserWarningComponent };
